@let _key = key();

<button [class]="twClasses()" [disabled]="disabled()" [animate.enter]="disabled() ? '' : 'anim-pop-in'" (click)="press()">
  @if (_key.type === 'KLANKVOET') {
    @switch (_key.value) {
      @case ('>') {
        <i-klankvoet-normal class="size-[1lh]" />
      }
      @case ('<') {
        <i-klankvoet-stom class="size-[1lh]" />
      }
    }
  } @else {
    {{ _key.value === 'sjwa' ? 'e' : _key.value.startsWith('(') ? _key.value.at(-1) : _key.value }}
  }
</button>
